/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect, useCallback, useContext, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { DependentContext, ThemeContext } from "../../../../../contexts";
import TabPanel from "../../../../shared/tabPanelComponent/TabPanel";
import a11yProps from "../../../../../constants/tabPanelProps/ayProps";

import { Box, Tabs, Tab, Paper } from "@mui/material";
import DependentInformation from "./dependentInformation/DependentInformation";
import DependentClaims from "./dependentClaims/DependentClaims";
import GroupBenefits from "./dependentBenefits/DependentBenefits";
import VEBBenefits from "./dependentBenefits/VEBDependentBenefits";
import { LazyDependentBenefits, LazyVEBDependentBenefits } from "../../..";
import ClaimList from "../../../claim/claimList/ClaimList";

import "./dependent.css";
import { useQuery } from "../../../../../hooks";
import { api } from "../../../../../utils/api";
import { trackPromise } from "react-promise-tracker";

const Dependent = () => {
	const [tabLabel, setTabLabel] = useState(0);
	const [dependentDetails, setDependentDetails] = useState(null);
	const { theme } = useContext(ThemeContext);
	const location = useLocation();
	const { setDependent } = useContext(DependentContext);
	const query = useQuery();
	// const history = useHistory();

	const handleLabelChange = useCallback((event, value) => {
		setTabLabel(value);
	}, []);

	// const getDependentDetails = () => {
	// 	setDependentDetails(Object.assign({}, location.state.dependent));
	// };

	const getMember = useCallback(async () => {
		if (query && query.get("id") && typeof query.get("id") === "string") {
			const _dependentDetails = await trackPromise(api.user.getMember(query.get("id")));
			setDependentDetails(Object.assign({}, _dependentDetails));
			setDependent(Object.assign({}, _dependentDetails));
		}
	}, [query, setDependent]);

	useEffect(() => {
		getMember();
	}, [getMember]);

	// console.log("Data Details", dependentDetails);

	//return <div>sdsd</div>;

	if (!dependentDetails) {
		return <></>;
	}

	return (
		<div className="dependent-details-container" id="dependent-details-container">
			<div className="dependent-paper-form-container">
				<Paper className="theme-border-radius dependent-paper-form-container" elevation={1}>
					<Box sx={{ width: "100%" }}>
						<Box sx={{ borderBottom: "none" }}>
							<Tabs
								value={tabLabel}
								onChange={handleLabelChange}
								TabIndicatorProps={{
									style: {
										border: "none",
										background: theme.primary_color
									}
								}}
								variant="scrollable"
								scrollButtons="auto"
								aria-label="scrollable auto tabs example"
								className="glb-tab-panel"
							>
								<Tab
									label={"Dependent"}
									{...a11yProps(0)}
									className="glb-tab-label"
									style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
								/>
								<Tab
									label={"Core Benefits"}
									{...a11yProps(1)}
									className="glb-tab-label"
									style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
								/>
								<Tab
									label={"VEB Benefits"}
									{...a11yProps(2)}
									className="glb-tab-label"
									style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
								/>
								<Tab
									label={"Claims"}
									{...a11yProps(3)}
									className="glb-tab-label"
									style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
								/>
							</Tabs>
						</Box>
						<TabPanel value={tabLabel} index={0}>
							<DependentInformation
								dependentDetails={dependentDetails}
								setDependentDetails={setDependentDetails}
							/>
						</TabPanel>
						<TabPanel value={tabLabel} index={1}>
							<Suspense fallback={<div />}>
								<LazyDependentBenefits />
							</Suspense>
						</TabPanel>
						<TabPanel value={tabLabel} index={2}>
							<Suspense fallback={<div />}>
								<LazyVEBDependentBenefits dependentDetails={dependentDetails} />
							</Suspense>
						</TabPanel>
						<TabPanel value={tabLabel} index={3}>
							<ClaimList />
						</TabPanel>
					</Box>
				</Paper>
			</div>
		</div>
	);
};

export default Dependent;
